module.exports = __webpack_public_path__ + "static/img/1-6.fde6ccca.png";